import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefGetUpoXmlQuery, KsefGetUpoXmlQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefGetUpoXmlQuery)
@Wrapper(KsefGetUpoXmlQueryHandlerBase)
export class KsefGetUpoXmlQueryHandler {
    public constructor(
        http: Http
    ) { }
}
